import React, { useState, lazy, Suspense } from "react";
import { Link, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import useWindowsSize from "../../Hooks/useWindowsSize";
import {
  DefaultCheckout,
  HeaderPlpMovil,
  HeaderPlpWeb,
  Navegation,
  NavMovil,
  FormPickUp,
  ProductCheckoutView,
  FormHomeAddress,
  PrintReceipt,
  DefaultTicket,
} from "@/Components/Index";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import type { BuyProduct } from "@/Models/MBuyPropduct/BuyProduct";
import type { MBuyFrom } from "@/Models/MBuyFrom/MBuyFrom";
import {
  useCheckoutAddOrderBuy,
  useDeleteOrderBuy,
  useTicketOrderBuy,
} from "@/Service/Api/Index";

const LazyHeaderWeb = lazy(() => import("@/Components/Header/HeaderWeb"));
const LazyHeaderMovil = lazy(() => import("@/Components/Header/HeaderMovil"));

type paramsData = {
  cteg?: string;
  subcateg?: string;
  id?: string;
  names?: string;
  quant?: string;
};

const stylesd: React.CSSProperties = { maxWidth: "233px" };

const CheckoutArticles: React.FC = () => {
  //
  const { id, cteg, subcateg, names, quant } = useParams<paramsData>();
  const { MDatos, isLoading } = useCheckoutAddOrderBuy(
    id!,
    cteg!,
    subcateg!,
    Number(quant)
  );
  const { CodeBarra, postData, checkoutBuySku } = useTicketOrderBuy();
  const { deleteData, eliminarOrderBuySku } = useDeleteOrderBuy(id!);
  //Loadding por Skeleton
  const [isLoading2, setIsLoading2] = useState<boolean>(false);
  const [ViewForm, setViewForm] = useState<boolean>(true);
  const [visivility, setVisivility] = useState<boolean>(false);
  const [OptionsBTN, setOptionsBTN] = useState<boolean>(false);
  const [PrintTitle, setPrintTitle] = useState<string>("");
  //screen de pantalla
  const { width } = useWindowsSize();

  //console.log("MDatos", MDatos);

  //url de navegación.
  let linkInicio = "/Electrónica";
  let pasoAnteriror = `${linkInicio}/${cteg}/${subcateg}/article/storeId/${id}/c`;
  //subCateg
  let urlSubcateg = `${linkInicio}/${cteg}/${subcateg}`;

  //************** Eliminar el basket id de carrito **************\\
  const clickDelete = async () => {
    try {
      const { basketId, skuId, ipAddress } = MDatos[0] ?? {};
      if (skuId == null || skuId == "" || basketId == null || basketId == "")
        return;

      //mandamos a llamar el endpoint
      //eliminamos el item del state
      await deleteData(eliminarOrderBuySku, {
        basketId: basketId,
        skuId: skuId,
        ipAddress: ipAddress,
      });
    } catch (error) {
      console.error(`[Error]:  ${error}`);
    }
  };

  //Seleccionar el metodo de entrega
  //Recoger en tienda o envio a domicilio
  const handleClick = (view: boolean) => {
    setPrintTitle("");
    setVisivility(true);
    setViewForm(view);
    if (view) setPrintTitle("Recoger en tienda");
    if (!view) setPrintTitle("Envío a domicilio");
  };

  //Generar ticket y mostramos el componente
  const generarTicket = () => setOptionsBTN(true);

  //cerrar formulario
  const visual = () => setVisivility(false);

  //Envio de datos del formulario
  const headleOnClickFrom = (formDatas: MBuyCarCheckout) => {
    setIsLoading2(true);
    setTimeout(() => {
      visual();
      generarTicket();
      responseEndPoint(formDatas);
      setIsLoading2(false);
    }, 10000);
  };

  //Boton del formulario, al el cual vamos a mandar los datos al api-rest.
  const responseEndPoint = async (formDatas: MBuyCarCheckout) => {
    const { skuId, quant, ipAddress } = MDatos[0] ?? {};

    const {
      Name,
      Ean,
      CConversionFactor,
      Unit,
      CSalesUnit,
      IsDigital,
      CSaleLimit,
      CCategory,
      CBadges,
      MinOrderQuantity,
      Price,
      StepQuantity,
      CListPrice,
      CSalesPrice,
    } = MDatos[0]?.productsItem ?? {};

    const dataPdp: BuyProduct = {
      skuId: skuId ?? "",
      productItems: [
        {
          //base_price: c_listPrice ?? 0,
          base_price: CListPrice ?? 0,
          cBarcode: Ean ?? "",
          c_conversionFactor: CConversionFactor ?? 0,
          c_fromStoreId: "",
          c_selectedUnit: Unit ?? "",
          c_selesUnit: CSalesUnit ?? "",
          cIsDigital: IsDigital ?? false,
          cSaleLimit: CSaleLimit ?? 0,
          cCategoryId: CCategory ?? "",
          cBadges: CBadges != null ? CBadges : "",
          cMinOrderQuantity: MinOrderQuantity ?? 0,
          inventoryId: "",
          item_id: skuId ?? "",
          price: Price ?? 0, //cSalesPrice
          productId: skuId ?? "",
          productName: Name?.toLowerCase() ?? "",
          quantity: quant ?? 0,
          stepQuantity: StepQuantity ?? 0,
          isDigital: IsDigital ?? false,
          sellLimit: CSaleLimit ?? 0,
          pricePromotion: 10, //xDefecto
          //se agrega la ip del cliente
          ipAddress: ipAddress ?? "",
          listPrice: CListPrice ?? 0,
          salePrice: CSalesPrice ?? 0,
        },
      ],
    };

    const MBasket_MFormData: MBuyFrom = {
      dataPdp: dataPdp,
      formData: formDatas,
    };

    //Verificamos que no venga null o vacio
    if (skuId == null || skuId == "") return;

    //mandamos a llamar el endpoint
    await postData(checkoutBuySku, MBasket_MFormData).finally(() => {
      setIsLoading2(false);
    });
  };

  return (
    <Suspense>
      {width > 1200 ? (
        <LazyHeaderWeb>
          <HeaderPlpWeb
            titles={""}
            toLink={pasoAnteriror}
            classNamesIcon={"icon-question-circle text-white"}
            onClickDelete={clickDelete}
          />
        </LazyHeaderWeb>
      ) : (
        <LazyHeaderMovil>
          <NavMovil classNames="align-items-center">
            <HeaderPlpMovil toLink={pasoAnteriror} title={""} toIcon={"/"} />
          </NavMovil>
        </LazyHeaderMovil>
      )}

      <div className="ps-page--my-account">
        {isLoading ? (
          <Skeleton className="w-100 p-2" />
        ) : !OptionsBTN ? (
          <Navegation
            classNames="ps-container"
            isLoading={isLoading}
            toLinkOne={"/"}
            toLinkTwo={"/Electrónica"}
            onClickDelete={clickDelete}>
            {isLoading ? (
              <Skeleton height={20} />
            ) : (
              <>
                <li className="text-truncate">
                  <Link
                    to={`${urlSubcateg}`}
                    className="link__develop"
                    onClick={clickDelete}>
                    {subcateg}
                  </Link>
                </li>
                <li
                  className="text-truncate"
                  style={width < 460 ? stylesd : {}}>
                  <Link
                    to={`${pasoAnteriror}`}
                    className="link__develop"
                    onClick={clickDelete}>
                    {MDatos[0]?.productsItem?.Name}
                  </Link>
                </li>
                <li className="text-truncate">Método de entrega</li>
                {OptionsBTN ? <li className="text-truncate">Ticket</li> : ""}
              </>
            )}
          </Navegation>
        ) : (
          ""
        )}
        <div className="container develop___top">
          {isLoading ? (
            <DefaultCheckout />
          ) : (
            <>
              {!OptionsBTN && (
                <ProductCheckoutView
                  MDatos={MDatos}
                  PrintTitle={PrintTitle}
                  clickDelete={clickDelete}
                  ViewForm={ViewForm}
                  handleClick={handleClick}
                />
              )}
              {
                <div className="ps-section__content">
                  {visivility ? (
                    ViewForm ? (
                      <FormPickUp
                        MDatos={MDatos}
                        headleOnClickFrom={headleOnClickFrom}
                        isLoading={isLoading2}
                      />
                    ) : (
                      <FormHomeAddress
                        MDatos={MDatos}
                        headleOnClickFrom={headleOnClickFrom}
                        isLoading={isLoading2}
                      />
                    )
                  ) : (
                    ""
                  )}
                  {OptionsBTN ? (
                    CodeBarra.length > 0 && CodeBarra ? (
                      <PrintReceipt
                        MOrderResponse={CodeBarra}
                        MDatos={MDatos}
                        PrintTitle={PrintTitle}
                      />
                    ) : (
                      <DefaultTicket />
                    )
                  ) : (
                    ""
                  )}
                </div>
              }
            </>
          )}
        </div>
      </div>
    </Suspense>
  );
};

export default CheckoutArticles;
